import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AdminAccessService } from '../admin-access/admin-access.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate, CanActivateChild {

  constructor(
    private router: Router,
    private adminAccessService: AdminAccessService
  ) { }

  /**
   * Protects administration routes by calling AdminAccessService.
   * If the user is an admin, activates the route. Otherwise, redirects to '/' and denies access.
   */
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const hasAccess = await this.adminAccessService.checkAdminAccess();
    if (hasAccess) {
      return true;
    } else {
      this.router.navigateByUrl('/');
      return false;
    }
  }

  async canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return await this.canActivate(childRoute, state);
  }
}
